import { useDispatch, useSelector } from 'react-redux';
import {
    SEARCH_LOCAL_STORAGE_ID, SEARCH_ACTION, SEARCH_OBJECT_TYPE, GA4_EVENT
} from '@common/GlobalSearch/constants';
import { useConfig } from '@common/Hooks/useConfig';
import { del, get, post } from '@common/Http';
import { RECENTS_SESSION_CACHE_NAME } from '@common/Recents/constants/cache';
import { isFeatureActive } from '@helpers/index';
import { useLocalStorageObject } from '@helpers/localStorage/hooks';
import { saveSession } from '@helpers/sessionStorage';
import {
    API_RECENT_SEARCH_REMOVE, API_RECENT_SEARCH_ADD, API_RECENT_SEARCHES_GET
} from '@routes';
import {
    addRecentSearch as addRecentSearchAction,
    overrideRecentSearches as overrideRecentSearchesAction,
    deleteAllRecentSearches as deleteAllRecentSearchesAction
} from '../actions';
import { convertToLowerCase } from '../helpers';
import { mapObjectTypeToTrackingType } from '../helpers/mapObjectTypeToTrackingType';

// This file will be refactor to Typescript
export const useRecentSearch = ({ limit } = {}) => {
    const config = useConfig();
    const dispatch = useDispatch();
    const {
        add: addToRecentSearches,
        override: overrideRecentSearches
    } = useLocalStorageObject(SEARCH_LOCAL_STORAGE_ID.newRecentSearches);

    const getRecentSearchesList = async () => {
        try {
            const { list } = await get(API_RECENT_SEARCHES_GET);

            overrideRecentSearches(list);
            dispatch(overrideRecentSearchesAction(list));
            saveSession(RECENTS_SESSION_CACHE_NAME, Date.now());
        } catch {}
    };

    const deleteAllRecentSearches = () => {
        del(`${API_RECENT_SEARCH_REMOVE}?all=true`);
        dispatch(deleteAllRecentSearchesAction());
    };

    const addRecentSearch = ({
        searchKey = '', action, objectType, navigationId, path, eanId, productId, suggestedQuery = ''
    }) => {
        const shouldTrackProductCards = isFeatureActive('PLT-47687-product-as-new-type-in-recent-searches', config);
        const isProductType = objectType === SEARCH_OBJECT_TYPE.product;
        const isHardSearch = action === SEARCH_ACTION.search;
        const trackingType = mapObjectTypeToTrackingType(objectType);
        const gender = App.Config.navGender;

        window.dataLayer?.push({
            event: GA4_EVENT.displaySearchResult,
            search_result_page: trackingType ?? objectType,
            search_term: convertToLowerCase(searchKey),
            search_suggested_query: suggestedQuery
        });

        if ((!shouldTrackProductCards && isProductType) || !searchKey) {
            return;
        }

        const dataToSend = {
            search_key: searchKey,
            action,
            object_type: objectType,
            navigation_id: navigationId || null,
            path: path || null,
            ean_id: eanId || null,
            product_id: productId || null
        };

        if (isHardSearch && gender) {
            dataToSend.gender = gender;
        }

        post(API_RECENT_SEARCH_ADD, dataToSend).then((response) => {
            addToRecentSearches(response.token, response);
            dispatch(addRecentSearchAction(response));
        });
    };

    const recentSearches = useSelector((state) => {
        const recentSearchList = state.globalSearch.recentSearches || [];

        return limit !== undefined ? recentSearchList.slice(0, limit) : recentSearchList;
    });

    return {
        getRecentSearchesList,
        deleteAllRecentSearches,
        addRecentSearch,
        recentSearches
    };
};
